import { Mail, Phone, MapPin } from "lucide-react";
import { PageShell, PolicySection } from "@/components/PageShell";
import { Contact } from "@/components/Contact";

export default function ContactUs() {
  return (
    <PageShell
      title="Contact Us"
      testid="contact-page"
      subtitle="Reach Findivine for general enquiries, donation-related questions, payment issues, receipts and refund requests — we read every message."
      after={<Contact />}
    >
      <PolicySection title="Findivine — One Kind Earth Foundation">
        <div className="grid sm:grid-cols-2 gap-4 not-prose">          <a
            href="mailto:info@findivine.org"
            data-testid="contact-page-email"
            className="flex items-center gap-4 bg-card border border-border rounded-xl p-5 hover:border-primary transition-colors"
          >
            <span className="w-11 h-11 rounded-full border border-border flex items-center justify-center shrink-0">
              <Mail size={17} />
            </span>
            <span>
              <span className="block text-xs uppercase tracking-widest text-muted-foreground">Email</span>
              <span className="text-foreground font-medium break-all">info@findivine.org</span>
            </span>
          </a>
          <a
            href="tel:+918875285537"
            data-testid="contact-page-phone"
            className="flex items-center gap-4 bg-card border border-border rounded-xl p-5 hover:border-primary transition-colors"
          >
            <span className="w-11 h-11 rounded-full border border-border flex items-center justify-center shrink-0">
              <Phone size={17} />
            </span>
            <span>
              <span className="block text-xs uppercase tracking-widest text-muted-foreground">Mobile</span>
              <span className="text-foreground font-medium">+91 8875285537</span>
            </span>
          </a>
          <div
            data-testid="contact-page-address"
            className="flex items-center gap-4 bg-card border border-border rounded-xl p-5 sm:col-span-2"
          >
            <span className="w-11 h-11 rounded-full border border-border flex items-center justify-center shrink-0">
              <MapPin size={17} />
            </span>
            <span>
              <span className="block text-xs uppercase tracking-widest text-muted-foreground">Registered Address</span>
              <span className="text-foreground font-medium">Vaishali Nagar, Jaipur, Rajasthan 302021</span>
            </span>
          </div>
        </div>
      </PolicySection>

      <PolicySection title="How we can help">
        <ul className="list-disc pl-6 space-y-2">
          <li>General enquiries about Findivine and our social welfare work.</li>
          <li>Donation-related questions, donation records and acknowledgements.</li>
          <li>Failed, pending, duplicate or incorrectly processed payment transactions.</li>
          <li>Receipt requests and refund or cancellation requests.</li>
        </ul>
        <p>
          You can write to us, call us, or use the contact form below. Messages sent through the form reach our team
          directly, and we aim to respond as quickly as possible.
        </p>
      </PolicySection>
    </PageShell>
  );
}
